module.exports = __webpack_public_path__ + "img/tx.fb1f14a5.png";